module.exports = __webpack_public_path__ + "static/media/idun13.bd24c743.JPG";